import { render, staticRenderFns } from "./ClassroomManagerInformation.vue?vue&type=template&id=4e974de6&scoped=true"
import script from "./ClassroomManagerInformation.vue?vue&type=script&lang=js"
export * from "./ClassroomManagerInformation.vue?vue&type=script&lang=js"
import style0 from "./ClassroomManagerInformation.vue?vue&type=style&index=0&id=4e974de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e974de6",
  null
  
)

export default component.exports